import { useApi } from './useApi';
import { BaseRequest, BaseHookRequest } from './useApi.types';
import {
  GetDocumentsResponse,
  GetSignedDocumentUrlsPayload,
  GetSignedDocumentUrlsResponse,
  ReviewDocumentPayload,
} from './useDocument.types';

export const useGetDocumentsRequests: BaseHookRequest<GetDocumentsResponse, null> = params => {
  const [{ getRequest }, state] = useApi<GetDocumentsResponse>(params);
  const getRequests: BaseRequest<null> = () => {
    return getRequest('/admin/document');
  };
  return [getRequests, state];
};

export const useGetSignedDocumentUrls: BaseHookRequest<
  GetSignedDocumentUrlsResponse,
  GetSignedDocumentUrlsPayload
> = params => {
  const [{ postRequest }, state] = useApi<GetSignedDocumentUrlsResponse>(params);
  const getSignedDocumentUrls: BaseRequest<GetSignedDocumentUrlsPayload> = details => {
    return details
      ? postRequest<GetSignedDocumentUrlsPayload>('/admin/document/signUrl', {
          ...details.variables,
        })
      : undefined;
  };
  return [getSignedDocumentUrls, state];
};

export const useReviewDocument: BaseHookRequest<undefined, ReviewDocumentPayload> = params => {
  const [{ postRequest }, state] = useApi<undefined>(params);
  const reviewDocument: BaseRequest<ReviewDocumentPayload> = details => {
    return details
      ? postRequest<ReviewDocumentPayload>('/admin/document/review', {
          ...details.variables,
        })
      : undefined;
  };
  return [reviewDocument, state];
};
